import React, { useState } from 'react';
import { Target, TrendingUp, AlertCircle, Save, RefreshCw, Search } from 'lucide-react';
export function ParManagement() {
  return <div className="space-y-6" data-id="element-882">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-883">
        <div className="bg-white p-6 rounded-2xl border border-slate-100 shadow-sm" data-id="element-884">
          <div className="flex items-center gap-3 mb-4" data-id="element-885">
            <div className="p-2 bg-blue-50 rounded-xl text-blue-600" data-id="element-886">
              <Target size={20} data-id="element-887" />
            </div>
            <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-888">
              Total PAR Value
            </p>
          </div>
          <p className="text-2xl font-black text-slate-900" data-id="element-889">$58,200</p>
          <p className="text-xs text-slate-500 mt-1 font-medium" data-id="element-890">
            Minimum stock value required
          </p>
        </div>
        <div className="bg-white p-6 rounded-2xl border border-slate-100 shadow-sm" data-id="element-891">
          <div className="flex items-center gap-3 mb-4" data-id="element-892">
            <div className="p-2 bg-amber-50 rounded-xl text-amber-600" data-id="element-893">
              <AlertCircle size={20} data-id="element-894" />
            </div>
            <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-895">
              Below PAR Items
            </p>
          </div>
          <p className="text-2xl font-black text-rose-600" data-id="element-896">14</p>
          <p className="text-xs text-slate-500 mt-1 font-medium" data-id="element-897">
            Items requiring immediate order
          </p>
        </div>
        <div className="bg-white p-6 rounded-2xl border border-slate-100 shadow-sm" data-id="element-898">
          <div className="flex items-center gap-3 mb-4" data-id="element-899">
            <div className="p-2 bg-emerald-50 rounded-xl text-emerald-600" data-id="element-900">
              <TrendingUp size={20} data-id="element-901" />
            </div>
            <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-902">
              Recommendations
            </p>
          </div>
          <p className="text-2xl font-black text-emerald-600" data-id="element-903">8</p>
          <p className="text-xs text-slate-500 mt-1 font-medium" data-id="element-904">
            Suggested PAR adjustments
          </p>
        </div>
      </div>

      <div className="bg-white rounded-2xl border border-slate-100 shadow-sm overflow-hidden" data-id="element-905">
        <div className="p-4 border-b border-slate-50 flex items-center justify-between" data-id="element-906">
          <div className="relative flex-1 max-w-md" data-id="element-907">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={16} data-id="element-908" />
            <input type="text" placeholder="Search items..." className="w-full pl-10 pr-4 py-2 bg-slate-50 border-none rounded-xl text-sm focus:ring-2 focus:ring-emerald-500/20 outline-none transition-all" data-id="element-909" />
          </div>
          <div className="flex items-center gap-2" data-id="element-910">
            <button className="flex items-center gap-2 px-4 py-2 bg-white border border-slate-200 rounded-xl text-sm font-bold text-slate-600 hover:bg-slate-50 transition-all shadow-sm" data-id="element-911">
              <RefreshCw size={16} data-id="element-912" />
              Recalculate
            </button>
            <button className="flex items-center gap-2 px-4 py-2 bg-emerald-500 text-white rounded-xl text-sm font-bold hover:bg-emerald-600 transition-all shadow-lg shadow-emerald-500/20" data-id="element-913">
              <Save size={16} data-id="element-914" />
              Save Changes
            </button>
          </div>
        </div>
        <div className="overflow-x-auto" data-id="element-915">
          <table className="w-full text-left border-collapse" data-id="element-916">
            <thead data-id="element-917">
              <tr className="bg-slate-50/50 border-b border-slate-100" data-id="element-918">
                <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-919">
                  Item
                </th>
                <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest text-center" data-id="element-920">
                  On Hand
                </th>
                <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest text-center" data-id="element-921">
                  Current PAR
                </th>
                <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest text-center" data-id="element-922">
                  Recommended
                </th>
                <th className="px-6 py-4 text-[10px] font-bold text-slate-400 uppercase tracking-widest text-right" data-id="element-923">
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-50" data-id="element-924">
              {[1, 2, 3, 4, 5].map(i => <tr key={i} className="hover:bg-slate-50/50 transition-colors" data-id="element-925">
                  <td className="px-6 py-4" data-id="element-926">
                    <p className="text-sm font-bold text-slate-900" data-id="element-927">
                      Inventory Item {i}
                    </p>
                    <p className="text-[10px] text-slate-400 font-medium uppercase tracking-wider" data-id="element-928">
                      Food Master
                    </p>
                  </td>
                  <td className="px-6 py-4 text-center text-sm font-bold text-slate-500" data-id="element-929">
                    12
                  </td>
                  <td className="px-6 py-4" data-id="element-930">
                    <div className="flex justify-center" data-id="element-931">
                      <input type="number" defaultValue={20} className="w-20 px-3 py-2 bg-slate-50 border border-slate-200 rounded-lg text-center text-sm font-bold focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 outline-none transition-all" data-id="element-932" />
                    </div>
                  </td>
                  <td className="px-6 py-4 text-center" data-id="element-933">
                    <span className="px-2 py-1 bg-emerald-50 text-emerald-600 text-[10px] font-black rounded uppercase border border-emerald-100" data-id="element-934">
                      25 (+5)
                    </span>
                  </td>
                  <td className="px-6 py-4 text-right" data-id="element-935">
                    <button className="text-emerald-600 text-[10px] font-black hover:underline uppercase" data-id="element-936">
                      Apply Recommendation
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}